import React from 'react';
import {useAppSelector} from "../../hooks/useAppSelector";
import {Roles} from "../../types/roles";
import {Navigate} from "react-router-dom";

const RepositoryIndexRedirect = () => {
    const roles = useAppSelector(state => state.user.user?.roles) || []

    const hasKrookie = roles.includes(Roles.KrookieJournal)
    const hasReports = roles.includes(Roles.ReportsJournal)
    const hasContractor = roles.includes(Roles.Contractor)

    if (hasKrookie && !hasReports) {
        return <Navigate to='krookie' replace/>
    } else if (!hasKrookie && hasReports) {
        return <Navigate to='reports' replace/>
    } else if (hasContractor) {
        return <Navigate to='utilities' replace/>
    }

    return null
};

export default RepositoryIndexRedirect;